import request from '@/request'
export const getpjlist = (data) => {
  return request({
    url: '/exFtuProductSatisfied/all.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const updatePageViews = (data) => {
  return request({
    url: '/exFtuProductSatisfied/updatePageViews.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const viewLogistics = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewLogistics.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const feedback = (data) => {
  return request({
    url: '/exFtuProductComplaint/add.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const evaluate = (data) => {
  return request({
    url: '/exFtuProductSatisfied/add.action',
    method: 'post',
    data,
    isMd5: false
  })
}
export const addTip = (data) => {
  return request({
    url: '/exterior_intFtuProductTip/addTip.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 查询快递公司名称
export const viewCompany = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewCompany.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 确认收货
export const receipt = (data) => {
  return request({
    url: 'exterior_intFtuProductLogisticsinfo/receipt.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 查询物流公司编码
export const viewexpressName = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewexpressName.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取订单号
export const getOrderNum = (data) => {
  return request({
    url: '/exterior_intFtuPayOrderInfo/getOrderNum.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 获取微信支付
export const getWechatPay = (data) => {
  return request({
    url: '/exterior_intFtuPayController/pay.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 积分商城获取秒杀时间段
export const getSeckill = (data) => {
  return request({
    url: '/exFtuProductSeckill/getSeckill.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 积分商城获取秒杀商品
export const getProduct = (data) => {
  return request({
    url: '/exFtuProductSeckill/getProduct.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 积分商城判断秒杀是否结束
export const timePanduan = (data) => {
  return request({
    url: '/exFtuProductSeckill/timePanduan.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 更新订单支付状态
export const updateZF = (data) => {
  return request({
    url: '/exterior_intFtuPayOrderInfo/updateZF.action',
    method: 'post',
    data,
    isMd5: false
  })
}
